import { render, staticRenderFns } from "./Block2.vue?vue&type=template&id=4bcf7035&scoped=true"
import script from "./Block2.vue?vue&type=script&lang=js"
export * from "./Block2.vue?vue&type=script&lang=js"
import style0 from "./Block2.vue?vue&type=style&index=0&id=4bcf7035&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcf7035",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bcf7035')) {
      api.createRecord('4bcf7035', component.options)
    } else {
      api.reload('4bcf7035', component.options)
    }
    module.hot.accept("./Block2.vue?vue&type=template&id=4bcf7035&scoped=true", function () {
      api.rerender('4bcf7035', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Block2.vue"
export default component.exports